// src/components/client-auth-provider.tsx
// 创建客户端包装器组件，用于解决模态化应用Clerk-登录、注册组件的客户端问题

// 保持架构分离：客户端逻辑被隔离在专门的包装器中
// 避免服务器组件污染：layout.tsx 保持干净，只负责布局
// 明确边界："use client" 指令只在必要时使用

'use client';

import { AuthProvider } from '../auth';

export default function ClientAuthProvider({
  children
}: {
  children: React.ReactNode
}) {
  return <AuthProvider>{children}</AuthProvider>;
}
